import Circle from 'assets/main/circle.avif'
import { motion } from 'framer-motion'
import { END_ANIMATION_PROPERTY, START_ANIMATION_PROPERTY, VIEWPORT_PROPERTY } from 'components/constants/animation-properties';
import Bg1 from "assets/main/bg1.avif";
import BgMo1 from "assets/main/bgMo1.avif";
import Bg2 from "assets/main/bg2.avif";
import BgMo2 from "assets/main/bgMo2.avif";
import { useEffect, useState } from 'react';
import Container from 'components/common/Container';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectFade, Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';
import CustomButton from 'components/common/CustomButton';
import { useGetUser } from 'atom/user';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';

const First = () => {
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 992);
    const user = useGetUser();
    const navigate = useNavigate();

    useEffect(() => {
        const handleResize = () => setIsMobile(window.innerWidth <= 992);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const handleSwiperInit = (swiper: any) => {
        const dot = swiper.pagination.el; // pagination DOM
        dot?.classList.add("container");
    };

    const goDetailQuote = () => {
        if (!user.id) {
            return toast.error('로그인 후 이용가능합니다.')
        }
        else {
            navigate('/quote/normal/create');
        }
    }

    return (
        <Swiper
            className='w-full h-[640px]'
            slidesPerView={1}
            modules={[EffectFade, Pagination, Autoplay]}
            autoplay={{
                delay: 4000,
            }}
            onSwiper={handleSwiperInit}
            loop
            pagination={{ clickable: true }}
            effect="fade"
        >
            <SwiperSlide className='w-full h-full'>
                <div className='relative bg-[#0A0B15] h-full overflow-hidden text-white'>
                    <div
                        className='top-0 left-0 z-10 absolute w-full h-full'
                        style={{ background: `url(${Circle}) center/cover no-repeat` }}></div>
                    <div
                        className='top-0 left-0 z-10 absolute w-full h-full'
                        style={{ background: `url(${isMobile ? BgMo1 : Bg1}) center/cover no-repeat` }}></div>

                    <Container className='z-10 relative flex flex-col justify-center items-start gap-10 mobile:gap-4 w-full h-full'>
                        <div className='text-left'>
                            <motion.h2
                                className='font-semibold text-40 mobile:text-xl'
                                initial={START_ANIMATION_PROPERTY}
                                whileInView={END_ANIMATION_PROPERTY}
                                viewport={VIEWPORT_PROPERTY}>
                                클릭 한번으로 물류의<br className="hidden xl:hidden lg:block" /> 맥박을 깨우다
                            </motion.h2>
                            <motion.h3
                                transition={{ delay: 0.1 }}
                                className="font-bold text-40"
                                initial={START_ANIMATION_PROPERTY}
                                whileInView={END_ANIMATION_PROPERTY}
                                viewport={VIEWPORT_PROPERTY}>
                                PulseOnShip
                            </motion.h3>
                        </div>

                        <div className='flex flex-col gap-10 text-left'>
                            <motion.p
                                className='mobile:text-base text-2xl'
                                transition={{ delay: 0.2 }}
                                initial={START_ANIMATION_PROPERTY}
                                whileInView={END_ANIMATION_PROPERTY}
                                viewport={VIEWPORT_PROPERTY}>
                                견적·트래킹·문서·리스크까지, <br />    클릭 한 번으로 전 과정 관리
                            </motion.p>
                            <div className='text-[#C5C5C5] text-lg'>
                                <motion.p
                                    transition={{ delay: 0.3 }}
                                    initial={START_ANIMATION_PROPERTY}
                                    whileInView={END_ANIMATION_PROPERTY}
                                    viewport={VIEWPORT_PROPERTY}>
                                    목적지·화물 정보 한 번 입력으로 자동 견적
                                </motion.p>
                                <motion.p
                                    transition={{ delay: 0.4 }}
                                    initial={START_ANIMATION_PROPERTY}
                                    whileInView={END_ANIMATION_PROPERTY}
                                    viewport={VIEWPORT_PROPERTY}>
                                    비교·수락까지 원스톱 처리
                                </motion.p>
                            </div>
                        </div>
                    </Container>
                </div>
            </SwiperSlide>

            <SwiperSlide>
                <div className='bg-[#F8F8F8] h-full overflow-hidden text-black'>
                    <div
                        className='top-0 left-0 z-0 absolute w-full h-full'
                        style={{ background: `url(${isMobile ? BgMo2 : Bg2}) center/cover no-repeat` }}></div>
                    <Container className='z-10 relative gap-10 mobile:gap-4 w-full h-full'>
                        <div
                            className='flex flex-col justify-center items-start gap-10 mobile:gap-4 w-full h-full'
                        >
                            <motion.h2
                                className='font-medium text-40 mobile:text-xl'
                                initial={START_ANIMATION_PROPERTY}
                                whileInView={END_ANIMATION_PROPERTY}
                                viewport={VIEWPORT_PROPERTY}>
                                <span className='font-bold'>상세견적</span>으로 <span className='font-bold'>쉽고 빠르게,</span><br /><span className='font-bold'>펄스온쉽</span>과 시작하세요
                            </motion.h2>
                            <motion.p
                                className='mobile:text-base text-2xl'
                                transition={{ delay: 0.1 }}
                                initial={START_ANIMATION_PROPERTY}
                                whileInView={END_ANIMATION_PROPERTY}
                                viewport={VIEWPORT_PROPERTY}>
                                냉장 · 위험물 · 각종 컨테이너 등<br />
                                물류 정보를 입력하고 견적을 클릭 한번에!
                            </motion.p>
                            <CustomButton
                                className='bg-primary w-full max-w-[214px]'
                                title='상세견적 바로가기'
                                onClick={goDetailQuote}
                            />
                        </div>
                    </Container>
                </div>
            </SwiperSlide>
        </Swiper>
    )
}

export default First